import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";

@Component({
  selector: "app-prefix-dec",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-dec.component.html",
  styleUrl: "./prefix-dec.component.less",
})
export class PrefixDecComponent extends PrefixComponent<string> {
  public max: Max;

  public commas: number;

  public constructor() {
    super({
      defaultValue: "0",
      updateOn: "blur",
    });
    this.max = 999999.99999;
    this.required = true;
    this.commas = 5;
    this.characters = ALLOWED_CHARACTERS["dec"];
  }
}
